module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-sl.51be4aaa.png";